export default __webpack_public_path__ + "static/media/LaProducer.546adca3.JPG";